import url from 'url';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import getLoginRedirect from '../../utils/auth/getLoginRedirect';
import { BaseLoader } from '../../components/Loader';
import AuthPageLoader from './AuthPageLoader';

class AuthPageRoute extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    const routeTo = this.getRouteRedirect();
    if (routeTo) {
      props.history.replace(routeTo);
    }
    this.state = { routeTo };
  }

  getRouteRedirect() {
    const { auth, location } = this.props;

    const loginRedirect = getLoginRedirect(auth, location);

    if (loginRedirect) {
      return url.format(loginRedirect);
    }
    return null;
  }

  render() {
    return this.state.routeTo ? (
      <BaseLoader />
    ) : (
      <AuthPageLoader {...this.props} />
    );
  }
}

export function mapStateToProps(state) {
  const { auth } = state;
  return { auth };
}

export default connect(mapStateToProps)(AuthPageRoute);
